module.exports = __webpack_public_path__ + "img/still (28).5f975d19.jpg";